import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h3 className="text-xs tracking-widest uppercase text-primary-500 font-medium mb-2">About</h3>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">关于我们</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">了解90影视背后的故事与坚持</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-lg p-8 md:p-10 border border-secondary-200/60">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-8">{aboutInfo.content}</p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
              {aboutInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}